// @format
//
// Phone call composer — mirrors init_email_composer_button_listeners. Opens
// #phoneComposerModal from a .phone-composer-button and runs the Twilio browser
// call flow (POST /calls to create the call log + get the number, then makeCall),
// reusing the same backend as the existing call button.

import { makeCall, hangupCall, muteCall, isCallMuted } from "../../twilio_voice";

export function initPhoneComposerListeners(): void {
  const modal = (): JQuery => $("#phoneComposerModal");

  const reset = (): void => {
    const m = modal();
    m.find("#phoneComposerStatus").removeClass("text-danger text-success").text("Ready to call");
    m.find("#phoneComposerCall").removeClass("d-none").prop("disabled", false);
    m.find("#phoneComposerMute").addClass("d-none").html('<i class="fas fa-microphone"></i> Mute');
    m.find("#phoneComposerHangup").addClass("d-none");
  };

  $(document).off("click", ".phone-composer-button").on("click", ".phone-composer-button", function () {
    const $button = $(this);
    const m = modal();
    m.data("bots-prospect-id", $button.data("bots-prospect-id"));
    m.find("#phoneComposerName").text($button.data("prospect-name") || "");
    m.find("#phoneComposerNumber").text($button.data("phone-number") || "");
    reset();
    m.modal("show");
  });

  $(document).off("click", "#phoneComposerCall").on("click", "#phoneComposerCall", function () {
    const m = modal();
    const $status = m.find("#phoneComposerStatus");
    m.find("#phoneComposerCall").addClass("d-none");
    m.find("#phoneComposerMute, #phoneComposerHangup").removeClass("d-none");
    $status.removeClass("text-danger text-success").text("Connecting…");

    $.ajax({
      url: "/calls",
      method: "POST",
      data: { bots_prospect_id: m.data("bots-prospect-id"), record: false, call_mode: "computer" },
      success: async function (resp: any) {
        try {
          const call = await makeCall({
            To: resp.prospect_phone,
            CallerId: resp.caller_id,
            Record: resp.record ? "true" : "false",
          });
          if (!call) {
            $status.addClass("text-danger").text("Could not start the call");
            reset();
            return;
          }
          call.on("ringing", () => $status.text("Ringing…"));
          call.on("accept", () => $status.addClass("text-success").text("In call"));
          call.on("disconnect", () => {
            $status.text("Call ended");
            reset();
          });
          call.on("cancel", () => reset());
          call.on("error", () => {
            $status.addClass("text-danger").text("Call error");
            reset();
          });
        } catch {
          $status.addClass("text-danger").text("Could not start the call");
          reset();
        }
      },
      error: function (xhr: any) {
        $status.addClass("text-danger").text((xhr.responseJSON && xhr.responseJSON.error) || "Failed to call");
        reset();
      },
    });
  });

  $(document).off("click", "#phoneComposerMute").on("click", "#phoneComposerMute", function () {
    const muted = !isCallMuted();
    muteCall(muted);
    $(this).html(muted ? '<i class="fas fa-microphone-slash"></i> Unmute' : '<i class="fas fa-microphone"></i> Mute');
  });

  $(document).off("click", "#phoneComposerHangup").on("click", "#phoneComposerHangup", function () {
    hangupCall();
    reset();
  });

  $("#phoneComposerModal").on("hidden.bs.modal", function () {
    hangupCall();
    reset();
  });
}
